import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify';
import cookie from 'react-cookies'

export const FETCH_USER_LIST = 'FETCH_USER_LIST'
export const RECEIVE_USER_LIST = 'RECEIVE_USER_LIST'
export const FAILED_USER_LIST = 'FAILED_USER_LIST'

export function fetchUserList(_data){
    return (dispatch, getState) => {
        dispatch({type: FETCH_USER_LIST})
        axios({
            method: 'POST',
            url: API_LINKS.USER_GET_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_USER_LIST,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_USER_LIST
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_USER_LIST
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            console.log(error)
            if (error.response){
                dispatch({
                    type: FAILED_USER_LIST
                })
                return toast.error(error.response.data.message);;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/users/aUser-userList.jsx